import {
  ACCESS_OVERVIEW_ROUTE,
  GLOBAL_ROUTE,
  PRODUCT_ROUTE,
} from "../core/routes";
import { MenuItem } from "./MenuItem";

export const productAdminMenuItems: MenuItem[] = [
  {
    id: "product",
    label: "Product",
    labelKey: "PRODUCT_ADMIN_PRODUCT",
    path: PRODUCT_ROUTE,
    roles: ["sysadmin"],
  },
  {
    id: "global",
    label: "Global",
    labelKey: "PRODUCT_ADMIN_GLOBAL",
    path: GLOBAL_ROUTE,
    roles: ["sysadmin"],
  },
  {
    id: "access",
    label: "Access",
    labelKey: "PRODUCT_ADMIN_ACCESS",
    roles: ["sysadmin"],
    children: [
      {
        id: "access_overview",
        label: "Overview",
        labelKey: "PRODUCT_ADMIN_ACCESS_OVERVIEW",
        path: ACCESS_OVERVIEW_ROUTE,
        roles: ["sysadmin"],
      },
    ],
  },
];
